import { render } from "./GradientLineChart.vue?vue&type=template&id=2083f004"
import script from "./GradientLineChart.vue?vue&type=script&lang=js"
export * from "./GradientLineChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/BLEIN/mi-stock-blein-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__